module.exports = {
  USER_DATA_CALLCENTER: 'userData',
  CALLCENTER_LOGIN_DATA_KEY: 'callcenterLoginData',
  LOGIN_DATA_KEY: 'loginData',
  AD_LOGIN_CALLCENTER: 'adLoginCallcenter'
};



// WEBPACK FOOTER //
// ./src/const/Cookie.js